import {WlRadioButtonGroup} from "./radioButtonGroup.component";

export * from './radioButtonGroup.component';
export default WlRadioButtonGroup;

customElements.define('wl-radio-button-group', WlRadioButtonGroup);
